import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataChangeClientService {
  private dataSource = new BehaviorSubject<any>(null);
  dataChanges$ = this.dataSource.asObservable();

  updateData(data: any) {
    this.dataSource.next(data);
  }
} 